<template>
    <footer class="footer" v-if="setup != null" id="footer">
        <div class="column-container">
            <div class="container">
                <div class="col-left">
                    <div class="footer-contacts" v-if="!reverse">
                        <div class="item" v-for="item in setup.footer_contacts">
                            <div class="item-icon">
                                <svgIcon name="pin-footer" class="icon-pin-footer"/>
                            </div>
                            <div class="adres">
                                <div class="top">
                                    {{item.region}}
                                </div>
                                <p>{{item.adres}}</p>
                            </div>
                            <div class="phone">
                                <a :href="'tel:' + item.phone">{{item.phone}}</a>
                            </div>
                        </div>
                    </div>
                    <div class="footer-contacts" v-else>
                        <div class="item" v-for="item in setup.footer_contacts.slice().reverse()">
                            <div class="item-icon">
                                <svgIcon name="pin-footer" class="icon-pin-footer"/>
                            </div>
                            <div class="adres">
                                <div class="top">
                                    {{item.region}}
                                </div>
                                <p>{{item.adres}}</p>
                            </div>
                            <div class="phone">
                                <a :href="'tel:' + item.phone">{{item.phone}}</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-center">
                    <div class="footer-social">
                        <h3>
                            <!-- <span v-if="lang == 'kz/'">Біз Сізбен барлық уақытта байланыстамыз</span> -->
                            <svgIcon name="social-footer" class="icon-social-footer"/>
                            <span>{{setup.footer_bazis_social_title}}</span>
                        </h3>
                        <div class="social-items">
                            <a :href="setup.footer_social_links.insta" class="social-item" target="_blank">
                                <svgIcon name="instagram" class="icon-instagram"/>
                            </a>
                            <a :href="setup.footer_social_links.face" class="social-item" target="_blank">
                                <svgIcon name="facebook" class="icon-facebook"/>
                            </a>
                            <!-- <a :href="setup.footer_social_links.telegram" class="social-item" target="_blank">
                                <svgIcon name="telegram" class="icon-telegram"/>
                            </a> -->
                        </div>
                    </div>
                </div>
                <div class="col-right">
                    <div class="footer-info">
                        <div class="copy">
                            <p>{{setup.copyright}}</p>
                        </div>
                        <div class="footer-links">
                            <ul>
                                <li><router-link :to="'/' + setup.politics.link">{{setup.politics.name}}</router-link></li>
                            </ul>
                        </div>
                        <div class="made-in">
                            <p>Developed by</p>
                            <a href="https://v-web.kz" target="_blank">Victory WEB</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
    import svgIcon from '@/components/partials/SvgIcon.vue';
    export default {
        name: 'AppFooter',
        data () {
            return {
                reverse: false,
                lang: window.GlobalLang,
            }
        },
        components: {
            svgIcon,
        },
        methods: {
        },
        computed: {
            setup() {
                return this.$store.state.pageSetup
            },
        },
        created() {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/footer/footer.scss';
</style>